import api from './api';

export const commentService = {
  // Get comments for a task
  getTaskComments: async (taskId, params = {}) => {
    const response = await api.get(`/comments/task/${taskId}`, { params });
    return response.data;
  },

  // Create comment (without attachments)
  create: async (data) => {
    const response = await api.post('/comments', data);
    return response.data;
  },

  // Create comment with attachments (multipart)
  createWithAttachments: async ({ taskId, content, isInternal, files }) => {
    const formData = new FormData();
    formData.append('taskId', taskId);
    formData.append('content', content || '');
    formData.append('isInternal', isInternal ? 'true' : 'false');

    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append('files', file);
      });
    }

    const response = await api.post('/comments/with-attachments', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Add attachment to existing comment
  addAttachment: async (commentId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post(`/comments/${commentId}/attachments`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Delete attachment
  deleteAttachment: async (attachmentId) => {
    const response = await api.delete(`/comments/attachments/${attachmentId}`);
    return response.data;
  },

  // Update comment
  update: async (id, data) => {
    const response = await api.put(`/comments/${id}`, data);
    return response.data;
  },

  // Delete comment
  delete: async (id) => {
    const response = await api.delete(`/comments/${id}`);
    return response.data;
  },
};

export default commentService;
